const configs = [
    {
        url: 'http://api.madmin.tradeprint.in',
        portSeries: '5',
    },
    {
        url: 'https://api.metaodds.net',
        portSeries: '6',
    }
]
const urlIndex = 1;
export const BASE_URL = configs[urlIndex].url;// "https://api-dev.tradeprint.in"; //'http://188.72.233.163';

export const BASE_URL_LOGIN = `${BASE_URL}:${configs[urlIndex].portSeries}001/`;//':4001/';
export const BASE_URL_M_ADMIN = `${BASE_URL}:${configs[urlIndex].portSeries}015/`;//':4003/';
export const BASE_URL_ADMIN = `${BASE_URL}:${configs[urlIndex].portSeries}003/`;//':4003/';